import React, { useState, useRef, useEffect } from 'react';
import { checkUserAuth } from '../firebase';
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import { Link } from "react-router-dom";
import Cookies from 'js-cookie';
import './header.css';
import { VscSettings } from "react-icons/vsc";
import { MdApps, MdBusinessCenter, MdOutlineBusinessCenter, MdSettings, MdSearch, MdCalculate, MdAccountBox, MdAccessibility, MdLabelOutline, MdSave, MdOutlineFavoriteBorder, MdOutlineMenuOpen, MdPlaylistPlay, MdVideoLibrary, MdStorefront, MdMenu, MdCall, MdSupportAgent, MdLastPage, MdPageview, MdFeedback, MdOutlineFeedback, MdOutlineAdminPanelSettings, MdDashboard, MdAdminPanelSettings, MdOutlineDashboardCustomize, MdPreview } from "react-icons/md";

import { CiCalculator2, CiSearch } from "react-icons/ci";
import { GrUserNew } from "react-icons/gr";
import { useNavigate, useLocation } from "react-router-dom";
import html2canvas from 'html2canvas';
import { RiPagesLine, RiUserCommunityFill, RiUserCommunityLine } from "react-icons/ri";
import { RiAccountCircleLine } from "react-icons/ri";
import { BiLogIn } from 'react-icons/bi';
import Logo from '../assets/logo.png';
import Photosicon from '../assets/photos_icon.png';
import { MdNightsStay, MdOutlineLightMode } from "react-icons/md";
import Messageshow from '../message_root/message-show';
import Chartshow from '../cart_root/cart-show';
import Menu_Popup from "./menu_popup.jsx";
export default function Bot() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [notification, setnotification] = useState(0);
  const [pricehistorydata, setpricehistorydata] = useState([]);
  const [photoURL, setPhotoURL] = useState("");
  const [loginName, setLoginName] = useState("");
  // Automatically check for logged-in user on page load
  const [menumobile, setMenumobile] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [guid, setguid] = useState(Cookies.get("guid"));
  //login
  const [userlogin, setuserlogin] = useState(false); // State for popup
  const popupRef = useRef(null);    // Ref for direct DOM manipulation
  const [search, setSearch] = useState(null);
  const [companyuid, setcompanyuid] = useState(Cookies.get("website_company_uid"));
  const [companydata, setcompanydata] = useState([]);
  const [admin_authentication, setadmin_authentication] = useState([]);
  const [adminlogin, setadminlogin] = useState(false);
  const [admineditor, setadmineditor] = useState(false);
  const [admindashboard, setadmindashboard] = useState(false);
  const [administration, setadministration] = useState(false);



  //
  useEffect(() => {
    const guids = Cookies.get("guid");
    const compuid = Cookies.get("website_company_uid");

    if (!compuid) return;

    setguid(guids);
    setcompanyuid(compuid);

    const q = query(
      collection(db, "companies"),
      where("companyuid", "==", compuid),
      where("status", "==", true)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        if (!snapshot.empty) {
          const data = snapshot.docs[0].data();
          setcompanydata(data);
        } else {
          setcompanydata(null);
        }
      },
      (error) => {
        console.error("Company detect error:", error);
      }
    );

    // ✅ cleanup listener
    return () => unsubscribe();

  }, []);

  //adminlogin
  useEffect(() => {
    if (!companyuid || !guid) return;

    const q = query(
      collection(db, "companies", companyuid, "admin_authentication"),
      where("accountguid", "==", guid),
      where("status", "==", true),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        if (!snapshot.empty) {
          const data = snapshot.docs[0].data();

          // ✅ FIX: remove [0]
          setadmindashboard(data.dashboard || false);
          setadmineditor(data.editor || false);

          setadministration(data.administration || false);
          setadmin_authentication(data);
          setadminlogin(true);
        } else {
          setadministration(false);
          setadmin_authentication(null);
          setadminlogin(false);
          setadmindashboard(false);
          setadmineditor(false);
        }
      },
      (error) => {
        console.error("Realtime error:", error);
      }
    );

    return () => unsubscribe();

  }, [companyuid, guid]);

  //prod  
  useEffect(() => {
    checkUserAuth(setUser);  // Auto-login
    const existingUser = Cookies.get("sessiontoken");   // Check for existing login
    setguid(Cookies.get("guid"));
    if (existingUser != null) {
      setuserlogin(true);
    } else {
      setuserlogin(false);   // Auto-open login popup if not logged in
    }
  }, []);
  const create_search = async (e) => {
    if (search == null || search.trim() === "") {
      return; // Exit if search is null or empty
    }
    navigate("/search?id=" + encodeURIComponent(search.trim()));
  };
  const enter_search = async (e) => {
    if (search == null || search.trim() === "") {
      return; // Exit if search is null or empty
    }
    if (e.key === "Enter") {
      navigate("/search?id=" + encodeURIComponent(search.trim()));
    }
  };
  //
  const [categoryproductsdata, setCategoryproductsdata] = useState([
    "Grow Your Business Online",
    "Zero Cost Selling"
  ]);
  const categories = [
    "Grow Your Business Online",
    "Zero Cost Selling",
    "Start Selling & Buying"
  ];
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) =>
        (prevIndex + 1) % categories.length
      );
    }, 2500); // change every 2 seconds

    return () => clearInterval(interval); // cleanup
  }, []);
  useEffect(() => {

    const handleResize = () => {
      const device = window.innerWidth;

      if (device > 768) {
        setMenumobile(false);
      } else {
        setMenumobile(true);
      }
    };

    handleResize(); // run once on load

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, []);


  //
  const [pagesdata, setpagesdata] = useState([]);

  useEffect(() => {

    const servicetablename = "companies";
    const tablename = "pages";

    const q = query(
      collection(db, servicetablename, companyuid, tablename),
      where("menu_status", "==", true),
      where("status", "==", true),
      orderBy("indexnumber", "asc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {

      const pages = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setpagesdata(pages);

    }, (err) => {
      console.error("Error fetching pages:", err);
    });

    // cleanup listener
    return () => unsubscribe();

  }, [companyuid]);


  return (
    <div className="header">
      {menumobile === false && adminlogin === true && (
        <div className='hd-tabs-body items-back-fill '>
          <div  >
            <div className='post-container'>
              <div className='post_div'>
                <div className='ui-grid-tabs'>
                  {admindashboard === true && (
                    <div className="ui-items-tabs  cursor center">
                      <div className='button-ui2 text-h2' onClick={() => navigate('/dashboard')}><MdOutlineDashboardCustomize className='icon' />Dashboard</div>
                    </div>
                  )}

                  {admineditor === true && (
                    <div className="ui-items-tabs  cursor center">
                      <div className='button-ui2 text-h2' onClick={() => navigate('/dashboard-editer')}><MdOutlineAdminPanelSettings className='icon' />Editer</div>
                    </div>
                  )}
                  <div className="ui-items-tabs  cursor center">
                    <div className='button-ui2 text-h2' onClick={() => navigate('/preview')}><MdPreview className='icon' />Preview</div>
                  </div>
                </div>
              </div>
              <div className='ppost_pos'>
                <div className='ui-grid-tabs'>


                  {administration === true && (
                    <div className="ui-items-tabs  cursor center">
                      <div className='button-ui2 text-h2' onClick={() => navigate('/administration')}><MdOutlineAdminPanelSettings className='icon' />Administration</div>
                    </div>
                  )}
                  {admineditor === true && (
                    <div className="ui-items-tabs  cursor center">
                      <div className='button-ui2 text-h2' onClick={() => navigate('/website-settings')}><MdSettings className='icon' />Settings</div>
                    </div>
                  )}
                  <div className="ui-items-tabs  cursor center">
                    <div className='button-ui2 text-h2' onClick={() => navigate('/create-account')}><RiPagesLine className='icon' />Billing</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
      <div className='header_size'>

        <div className="left_body">
          {menumobile === true && (
            <div onClick={() => setMenuOpen(true)} className="button-menu cursor "><MdMenu className="menu_icon" /></div>
          )}
          <div className="logo-div" onClick={() => navigate('/')}>
            <img src={Logo} alt="Logo" className="brand-logo" />
            <div className='logo-name fcap'>{companydata.name}<a className='logo-name-sub'></a>

            </div>
          </div>
        </div>
        <div className='menus_body'>

          {/* {userlogin === true && ( 

            <div
              onClick={() => navigate('/dashboard')}
              className={`menubutton-icon ${location.pathname === '/dashboard' ? 'active' : ''}`}
              title="Dashboard"
            >

              <span className="button-text">Dashboard</span>
            </div>
          )
          } */}
          {/* <div
            onClick={() => navigate('/about')}
            className={`menubutton-icon  ${location.pathname === '/about' ? 'active' : ''}`}
            title="About"
          >
            {location.pathname === '/ads' ? <BsPersonVideo2 className="icon" /> : <BsPersonVideo2 className="icon" />}
            <span className="button-text">About</span>
          </div> */}

          {/*        
          <div
            onClick={() => navigate('/support')}
            className={`menubutton-icon ${location.pathname === '/support' ? 'active' : ''}`}
            title="about"
          >

            <span className="button-text">Support</span>
          </div>   */}
        </div>
        <div className='search-body'>
          <CiSearch className='search-icon' />
          <input
            className="search_input text-h1 fcap"
            value={search}
            maxLength={100}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={`Search ${categories[placeholderIndex]}`}
          />
          <div className='search_btn_div'>
            <VscSettings className='search_btn' onClick={(e) => create_search()} />
          </div>

        </div>

        <div className="right_body">
          <div className='searchdiv' onClick={() => navigate('/search')}>

            <CiSearch className='search_icon' /></div>


          <div className='itemdiv' title='support' onClick={() => navigate('/support')}>

            <MdSupportAgent className='apps_icon blue' /></div>
          {/* <div className='itemdiv' onClick={() => navigate('/seller')}>

            <MdStorefront className='apps_icon' /></div> */}

          {userlogin ? (
            <div className='account-sttings' onClick={() => navigate('/account')}>
              <img
                src={Cookies.get("login_photoURL") || Photosicon}
                onError={(e) => { e.currentTarget.src = Photosicon; }}
                className="Photos-icon rounded-circle shadow hover"
              />
            </div>
          ) : (
            <div className='account-sttings'>
              <div className='button-ui p-2' onClick={() => navigate('/login')} >    <RiAccountCircleLine className="icon" />Login</div>
            </div>
          )}

          {/* <div className='itemdiv' onClick={() => navigate('/message')}>
                                <Messageshow /></div>   */}


        </div>
      </div>

      {menumobile === false && (
        <div className='hd-tabs-body  p-2'>
          <div  >
            <div className='post-container'>
              <div className='post_div'>
                <div className='ui-grid-tabs'>
                  {pagesdata.map((page) => (
                    <div key={page.id}
                      onClick={() => {
                        if (!page?.slug) return;
                        const path = page.slug === "home" ? "/" : `/${page.slug}`;
                        if (window.location.pathname !== path) {
                          navigate(path);
                        }
                      }}
                      className="ui-items-tabs cursor center">
                      <a className="hover-u text-h2 fcap">
                        {page.page_name}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
              <div className='ppost_pos'>
                <div className='ui-grid-tabs'>
                  <div className="ui-items-tabs  cursor text-r">
                    <div className=' text-h2 hover-u  ' onClick={() => navigate('/explore')}>Explore more</div>
                  </div>


                  <div className="ui-items-tabs  cursor text-r">
                    <div className=' text-h2 hover-u ' onClick={() => navigate('/feedback')}>Feedback</div>
                  </div>
                  <div className="ui-items-tabs  cursor text-r">
                    <div className=' text-h2 hover-u ' onClick={() => navigate('/contact')}>Contact</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Menu_Popup isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </div>
  );
}